import React from 'react';
import { HeatmapFilters } from './types/HeatmapTypes';

interface Props {
  filters: HeatmapFilters;
  onFiltersChange: (filters: HeatmapFilters) => void;
}

const Controls: React.FC<Props> = ({ filters, onFiltersChange }) => {
  const selectClasses = "mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 text-sm px-3 py-2 border bg-white";
  const inputClasses = "mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 text-sm px-3 py-2 border bg-white";
  const labelClasses = "flex items-center gap-2 text-xs font-semibold text-gray-700 uppercase tracking-wide";

  return (
    <div className="bg-white border-b border-gray-200 shadow-sm">
      <div className="px-6 py-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="flex-1">
            <label className={labelClasses}>
              ⏱️ Time Range
            </label>
            <select
              className={selectClasses}
              value={filters.hours}
              onChange={e => onFiltersChange({ ...filters, hours: Number(e.target.value) })}
            >
              <option value={1}>Last 1 hour</option>
              <option value={6}>Last 6 hours</option>
              <option value={24}>Last 24 hours</option>
              <option value={168}>Last 7 days</option>
              <option value={720}>Last 30 days</option>
            </select>
          </div>

          <div className="flex-1">
            <label className={labelClasses}>
              📍 Resolution
            </label>
            <select
              className={selectClasses}
              value={filters.resolution}
              onChange={e => onFiltersChange({ ...filters, resolution: Number(e.target.value) })}
            >
              <option value={2}>~11km (City)</option>
              <option value={3}>~1.1km (Street)</option>
              <option value={4}>~110m (Building)</option>
            </select>
          </div>

          <div className="flex-1">
            <label className={labelClasses}>
              # Min Events
            </label>
            <input
              type="number"
              className={inputClasses}
              min="1"
              max="100"
              value={filters.minCount}
              onChange={e => onFiltersChange({ ...filters, minCount: Number(e.target.value) })}
            />
          </div>

          <div className="flex-1">
            <label className={labelClasses}>
              👥 Top Locations / User
            </label>
            <input
              type="number"
              className={inputClasses}
              min="10"
              max="500"
              step="10"
              value={filters.limitPerIccid}
              onChange={e => onFiltersChange({ ...filters, limitPerIccid: Number(e.target.value) })}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Controls;

